import { DayOfWeek } from '@askporter/grieg-types';
import { days } from './';

export const sortDays = (a: DayOfWeek, b: DayOfWeek): number => {
  return days[a] - days[b];
};
